var map = {
	"./ar/translations.json": 6535,
	"./en-US/translations.json": 7414,
	"./en/translations.json": 40727,
	"./es-ES/translations.json": 30729,
	"./es-US/translations.json": 6617,
	"./sv-SE/translations.json": 48416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50353;